import { render, staticRenderFns } from "./Vervalkl.vue?vue&type=template&id=2650722b"
import script from "./Vervalkl.vue?vue&type=script&lang=js"
export * from "./Vervalkl.vue?vue&type=script&lang=js"
import style0 from "./Vervalkl.vue?vue&type=style&index=0&id=2650722b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports